/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationProperties200ResponseMeta } from './GetOrganizationProperties200ResponseMeta';
import {
    GetOrganizationProperties200ResponseMetaFromJSON,
    GetOrganizationProperties200ResponseMetaFromJSONTyped,
    GetOrganizationProperties200ResponseMetaToJSON,
    GetOrganizationProperties200ResponseMetaToJSONTyped,
} from './GetOrganizationProperties200ResponseMeta';
import type { ContactPropertyLink } from './ContactPropertyLink';
import {
    ContactPropertyLinkFromJSON,
    ContactPropertyLinkFromJSONTyped,
    ContactPropertyLinkToJSON,
    ContactPropertyLinkToJSONTyped,
} from './ContactPropertyLink';

/**
 * 
 * @export
 * @interface ContactPropertiesResponse
 */
export interface ContactPropertiesResponse {
    /**
     * 
     * @type {Array<ContactPropertyLink>}
     * @memberof ContactPropertiesResponse
     */
    contactProperties: Array<ContactPropertyLink>;
    /**
     * 
     * @type {GetOrganizationProperties200ResponseMeta}
     * @memberof ContactPropertiesResponse
     */
    meta?: GetOrganizationProperties200ResponseMeta;
}

/**
 * Check if a given object implements the ContactPropertiesResponse interface.
 */
export function instanceOfContactPropertiesResponse(value: object): value is ContactPropertiesResponse {
    if (!('contactProperties' in value) || value['contactProperties'] === undefined) return false;
    return true;
}

export function ContactPropertiesResponseFromJSON(json: any): ContactPropertiesResponse {
    return ContactPropertiesResponseFromJSONTyped(json, false);
}

export function ContactPropertiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPropertiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contactProperties': ((json['contactProperties'] as Array<any>).map(ContactPropertyLinkFromJSON)),
        'meta': json['meta'] == null ? undefined : GetOrganizationProperties200ResponseMetaFromJSON(json['meta']),
    };
}

export function ContactPropertiesResponseToJSON(json: any): ContactPropertiesResponse {
    return ContactPropertiesResponseToJSONTyped(json, false);
}

export function ContactPropertiesResponseToJSONTyped(value?: ContactPropertiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactProperties': ((value['contactProperties'] as Array<any>).map(ContactPropertyLinkToJSON)),
        'meta': GetOrganizationProperties200ResponseMetaToJSON(value['meta']),
    };
}

